import React from 'react';
import {
  ContentContainer,
  MainContainer,
  SubTableContainer,
} from '../../../components/atoms/tableData/styles/contentContainer.styles';
import GcspTable from '../../../components/templates/gcsp/forecast/tableComponent/gcspTable';
import GcspTableData from '../../../components/templates/gcsp/forecast/tableComponent/gcspTableData';
import SubHeaderGcsp from '../../../components/molecules/dcsp/components/subHeaderGcsp';
import PastSubHeaderGcsp from '../../../components/molecules/dcsp/components/pastSubHeaderGcsp';
import GcspPastTable from '../../../components/templates/gcsp/forecast/tableComponent/gcspPastTable';
import GcspPastTableData from '../../../components/templates/gcsp/forecast/tableComponent/gcspPastTableData';
import AlertBanner from '../../../components/atoms/alerts/alertBanner';
function GcspPastForecast(props) {
  let account = props.data.account;
  let forecast_type = props.data.forecast_type;
  let year = props.data.year;
  let month = props.data.month;
  month = month.charAt(0).toUpperCase() + month.slice(1);
  let quarter = props.data.quarter;
  let email = props.data.email;
  return (
    <>
      <MainContainer>
        <ContentContainer>
          <AlertBanner
            title={'NOTE'}
            description={'This is a view-only snapshot of the forecast you submitted.'}
            type={'past'}
          />
          <PastSubHeaderGcsp
            year={year}
            forecast_type={forecast_type}
            month={month}
            quarter={quarter}
            email={email}
            account={account}
          />
          <GcspPastTable
            email={email}
            year={year}
            month={month}
            quarter={quarter}
            forecast_type={forecast_type}
            account={account}
          />
        </ContentContainer>
      </MainContainer>
    </>
  );
}

export default GcspPastForecast;
